/**
 * @generated SignedSource<<11418aed40268df6a178f2eb1ac3ed9c>>
 * @relayHash da636d53dfab36377f32f6566e2d1fcd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 225ecf28165b03c12f0a9df2da762878464f4e900d5ad2b50a868275aa357175

import type { ConcreteRequest, Query } from 'relay-runtime';
export type quickFilters_Spa_Query$variables = {
  boardId: string;
  isCMP?: boolean | null | undefined;
};
export type quickFilters_Spa_Query$data = {
  readonly boardScope: {
    readonly __id: string;
    readonly currentUser: {
      readonly permissions: ReadonlyArray<AGG$SoftwareBoardPermission | null | undefined>;
    };
    readonly customFilters: ReadonlyArray<{
      readonly description: string | null | undefined;
      readonly filterQuery: {
        readonly sanitisedJql: string;
      } | null | undefined;
      readonly id: string;
      readonly name: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type quickFilters_Spa_Query = {
  response: quickFilters_Spa_Query$data;
  variables: quickFilters_Spa_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isCMP"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  },
  {
    "kind": "Variable",
    "name": "isCMP",
    "variableName": "isCMP"
  }
],
v2 = {
  "concreteType": "CurrentUser",
  "kind": "LinkedField",
  "name": "currentUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "permissions"
    }
  ]
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "concreteType": "CustomFilter",
  "kind": "LinkedField",
  "name": "customFilters",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "FilterQuery",
      "kind": "LinkedField",
      "name": "filterQuery",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "sanitisedJql"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "description"
    }
  ]
},
v5 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "quickFilters_Spa_Query",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "quickFilters_Spa_Query",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v3/*: any*/),
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "225ecf28165b03c12f0a9df2da762878464f4e900d5ad2b50a868275aa357175",
    "metadata": {},
    "name": "quickFilters_Spa_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7f04ccfd7774bcd93acab4ef8eb3c927";

export default node;
